// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ud82","input":"styles_input__3pqog"};